import { POLL_SINGLE as QuestionType } from '../../../../../poll';
import { PollConfig } from '../../../../configFields';
import { SINGLE_TYPE } from '../../../../configFields';

export const config: PollConfig & { name: 'POLL_SINGLE' } = {
  name: 'POLL_SINGLE' as const,
  traits: [SINGLE_TYPE],
  title: 'Одиночный выбор',
  tracker: (question: QuestionType) => {
    return trackingData => ({
      ...trackingData,
      question_type: question.data.image ? 'POLL_SINGLE_WITH_PICTURE' : 'POLL_SINGLE',
    });
  },
};
